let _this =  {


	/*-------------------------------------------------------------------------------
		# Cache dom and strings
	-------------------------------------------------------------------------------*/
	$dom: {
        body: $('body')
    },

    vars: {
    },

    /*-------------------------------------------------------------------------------
        # Initialize
    -------------------------------------------------------------------------------*/
    init: function () {

        // Check if .franli-block-content-table exists on the page
        if ($('.franli-block-content-table').length > 0) {

            // Select the h2 elements within the .entry-content section
            var $h2Elements = $('.entry-content h2');

            // Generate an anchor link for each h2 element and append it to the content table list
            $h2Elements.each(function() {
                var $h2Element = $(this);
                var title = $h2Element.text();
                var slug = title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
                $h2Element.attr('id', slug);
                var $li = $('<li class="franli-block-content-table__list-item"><span class="franli-block-content-table__list-item-icon"></span><a href="#' + slug + '">' + title + '</a></li>');
                $('.franli-block-content-table__list').append($li);
            });

            // Add a click event listener to the anchor links
            $('.franli-block-content-table__list a').on('click', function (e) {
                e.preventDefault();
                var target = $(this).attr('href');
                var offset = $(target).offset().top - 100;
                $('html, body').animate({
                    scrollTop: offset
                }, 500);
            });

        }
    },
};

export default _this;